// src/theme.js

export const colors = {
    backgroundGradient: ['#ff7e5f', '#feb47b', '#ff7e5f'],
    textPrimary: '#fff',
    textShadow: '#ffa502',
    confettiColors: ['#ff6b81', '#70a1ff', '#7bed9f', '#eccc68'],
    fireworksColors: ['#ff4757', '#3742fa', '#2ed573', '#ffa502'],
  };
  